export enum PartyScanResult {
  Submit = "SUBMIT",
  Cancel = "CANCEL",
  Passed = "PASSED",
}
